<template>
  <div class="loading-container">
    <div class="loading-icon">
      加载中
    </div>
  </div>
</template>

<script>

export default {
  name: 'Loading',
};
</script>

<style lang="scss" scoped>
.loading-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #F3F3F3;
  text-align: center;
  z-index: 1000000;
  .loading-icon {
    position: relative;
    display: inline-block;
    height: 66px;
    line-height: 66px;
    margin-top: 508px;
    padding: 0 24px 0 66px;
    border-radius: 12px;
    font-size: 26px;
    font-weight: bold;
    background: rgba(0, 0, 0, .8);
    color: #FFF;
    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 24px;
      width: 30px;
      height: 30px;
      margin-top: -15px;
      background: url(~@/assets/img/loading@2x.png) no-repeat;
      background-size: 30px;
      animation: rotate 1.5s infinite linear;
    }
  }
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
